/**
 * 检查 SDK API 返回的结果是否 ok
 * @param res
 * @returns {*|boolean}
 */
export function checkResOK(res) {
    return res && res.code === 0 && res.data;
}

/**
 * 检查 SDK 创建相关 API 返回的创建结果是否 ok
 * @param createRes
 * @returns {*|boolean}
 */
export function checkCreateResOK(createRes) {
    return createRes && createRes.code === 0 && createRes.data && createRes.data.id;
}

/**
 * 从返回的创建结果中获取实例 id
 * @param createRes
 * @returns {null}
 */
export function getCreatedInstanceId(createRes) {
    let id = null
    if(checkCreateResOK(createRes)){
        id = createRes.data.id
    }
    return id
}